<template>
  <v-card
    outlined
    class="backoffice-table"
    style="box-shadow: none !important;"
  >
    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      :server-items-length="totalItems"
      hide-default-footer
      @page-count="pageCount = $event"
      @update:page="requestPage($event)"
      class="elevation-1"
      :loading="loading"
      :mobile-breakpoint="0"
    >
      <template v-slot:top>
        <v-toolbar flat color="transparent">
          <v-spacer></v-spacer>
          <v-text-field
            class="search-feild"
            v-model="search"
            append-icon="mdi-magnify"
            placeholder="Pesquisar por"
            dense
            solo
            flat
            filled
            hide-details
            @keydown.enter="getItems(0, itemsPerPage)"
          ></v-text-field>
        </v-toolbar>
      </template>
      <!-- Status Template -->
      <template v-slot:[`item.status`]="{ item }">
        <v-chip
          class="invoice-chip"
          label
          small
          :class="
            item.status == 'settled'
              ? 'result-success'
              : item.status == 'canceled'
              ? 'result-fail'
              : item.status == 'draft'
              ? 'result-warning'
              : ''
          "
          >{{
            item.status == "settled"
              ? "P"
              : item.status == "canceled"
              ? "C"
              : item.status == "draft"
              ? "R"
              : "N/A"
          }}</v-chip
        >
      </template>
      <!-- Date Template -->
      <template v-slot:[`item.date`]="{ item }" >
        {{ $moment(item.date, "DD/MM/YYYY").format("YYYY-MM-DD")}}
      </template>
      <!-- Date Template -->
      <template v-slot:[`item.total`]="{ item }" >
        € {{ item.total }}
      </template>
      <!-- Actions Template -->
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          depressed
          dark
          color="#D8E0E6"
          class="gray-button"
          @click="getPdf(item.id, items.indexOf(item))"
          style="margin-right: 8px;"
          :loading="loadingBtns[items.indexOf(item)]"
          >Ver documento {{loadingBtns[items.indexOf(item)]}}</v-btn
        >
      </template>
      <template v-slot:[`body.append`]="{ headers }">
        <tr v-for="n in itemsPerPage - items.length" :key="'tr-' + n">
          <td :colspan="headers.length"></td>
        </tr>
      </template>
    </v-data-table>
    <div class="pagination">
      <v-pagination v-model="page" :length="pageCount" :total-visible="7"></v-pagination>
    </div>
  </v-card>
</template>

<style scoped>
.backoffice-table >>> tr td:nth-child(1) {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.pagination >>> .v-application .primary {
    background-color: red !important;
}
@media only screen and (max-width: 1024px) {
  .backoffice-table >>> .v-data-table__wrapper {
    overflow: auto;
  }
  .backoffice-table >>> table {
    width: 1180px;
  }
}
</style>

<script>
import Vue from "vue";

import ApiService from "@/services/api.service";

export default Vue.extend({
  name: "InvoicesTable",
  components: {},
  props: { data: {} },
  data: () => ({
    dialog: false,
    loading: false,
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    search: "",
    headers: [
      { text: "", value: "status", sortable: false },
      { text: "Data", value: "date", sortable: false },
      { text: "Total", value: "total", sortable: false },
      { text: "Descrição", value: "items[0].name", sortable: false },
      { text: "Cliente", value: "client.name", sortable: false },
      { text: "", align: "end", value: "actions", sortable: false }
    ],
    items: [],
    loadingBtns: [],
    totalItems: 0,
  }),
  created() {
    this.getItems(0, this.itemsPerPage);
  },
  methods: {
    getItems(page, size) {
      this.loading = true;
      ApiService.getInvoices(this.search, page, size).then(
        response => {
          this.loadingBtns = [false, false, false, false, false, false, false, false, false, false];
          this.items = this.sortArray(response.data.invoices);
          this.totalItems = response.data.pagination.total_entries;
          this.loading = false;
        },
        error => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    getPdf(invoiceId, index) {
      this.loading = true;
      this.loadingBtns[index] = true;
      //Vue.set(this.loadingBtns, index, true);
      ApiService.getInvoicePdf(invoiceId).then(
        response => {
          const pdfUrl = response.data.output.pdfUrl;
          console.log(pdfUrl);
          window.open(pdfUrl, '_blank');
          this.loadingBtns[index] = false;
          this.loading = false;
        },
        error => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    requestPage(page) {
      this.getItems(page - 1, this.itemsPerPage);
    },
    sortArray(array) {
      return array.sort(function(a, b) {
        // ASC  -> a.length - b.length
        // DESC -> b.length - a.length
        return b.id - a.id;
      });
    }
  }
});
</script>